export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_AngularJS-ce7c6b517285d3d0ce20d5975f788f86.jpg";